/*
 * Quick-add for collection/home product cards.
 * Posts to /cart/add.js via fetch so the page doesn't navigate.
 * Recharge Cart's fetch interceptor will see the request and open its drawer.
 * Skips PDP forms (AddToCartForm_id) — Recharge handles those directly.
 */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.add_to_cart_btn_cls');
  if (!btn) return;
  var form = btn.closest('form[action^="/cart/add"]');
  if (!form) return;
  if (form.classList.contains('AddToCartForm_id')) return;
  e.preventDefault();
  btn.setAttribute('disabled', true);
  var formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    // Update cart count badge
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var badges = document.querySelectorAll('.cart_qty_cls');
      badges.forEach(function(el) {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden-count', cart.item_count === 0);
      });
      var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
      bubbles.forEach(function(el) { el.textContent = cart.item_count; });
    });
  })
  .catch(function(err) { console.error('Quick-add error:', err); })
  .finally(function() { btn.removeAttribute('disabled'); });
});
